export default __webpack_public_path__ + "static/media/62.397b8a3a.png";